import { createRouter } from "@tanstack/react-router";
import { routeTree } from "./routeTree.gen";

export const getRouter = () => {
  const router = createRouter({
    routeTree,
    scrollRestoration: false,
    defaultPreload: false,
    defaultPreloadStaleTime: 0,
    defaultPendingMs: 0,
  });

  return router;
};
